import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { useTranslations } from '@/hooks/useTranslations';
import { useState } from 'react';

export const ClearCacheButton = () => {
  const { toast } = useToast();
  const { t } = useTranslations();
  const [isClearing, setIsClearing] = useState(false);

  const handleClearCache = async () => {
    setIsClearing(true);
    try {
      // Vider tous les caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
      }

      // Envoyer message au service worker pour forcer le vidage
      if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage('CLEAR_CACHE');
      }

      // Désinscrire tous les service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(registration => registration.unregister()));
      }

      toast({
        title: "Cache vidé",
        description: "Le cache a été vidé avec succès. La page va se recharger.",
      });

      // Recharger après un court délai
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error('Erreur lors du vidage du cache:', error);
      toast({
        title: "Erreur",
        description: "Impossible de vider le cache complètement.",
        variant: "destructive",
      });
      setIsClearing(false);
    }
  };

  return (
    <Button
      onClick={handleClearCache}
      disabled={isClearing}
      variant="outline"
      className="bg-white/80 backdrop-blur-sm shadow-lg hover:shadow-xl transition-all"
    >
      <Trash2 className="h-4 w-4 mr-2" />
      {isClearing ? 'Vidage...' : 'Vider le cache'}
    </Button>
  );
};
